import * as nodeUtils from "./nodeUtils";

export const validateSingleFunction = (root, name) => {
  const functions = nodeUtils.getFunctions(root);

  if (functions.length !== 1) {
    return { res: false, msg: "There should be exactly one function in the model." };
  }

  if (name) {
    if (nodeUtils.getName(functions[0]) !== name) {
      return { res: false, msg: `The function should be named ${name}.` };
    }
  }

  return { res: true, msg: "OK" };
};

export const validateParameters = (root, global, fixed, names) => {
  const parent = global ? root : nodeUtils.getFunctions(root)[0];

  if (!parent) {
    throw new Error("The parent is non-existent");
  }

  const elements = nodeUtils.getParameters(parent).map((e) => nodeUtils.getName(e));

  const missingElements = [];

  names.forEach((name) => {
    if (!elements.includes(name)) {
      missingElements.push(name);
    }
  });

  if (missingElements.length > 0) {
    return {
      res: false,
      msg: `The following parameters are missing: ${missingElements.join(", ")}`,
    };
  }

  return { res: true, msg: "OK" };
};

export const validateParametersLinked = (root, parent, names) => {

  const ref = nodeUtils.getParameters(root).filter(e => nodeUtils.getName(e) === parent);

    if (!ref) {
    throw new Error("The global parameter is non-existent");
  }
  const idRef = nodeUtils.getID(ref[0]);

  const funcs = nodeUtils.getFunctions(root);
  const paramsLinked = nodeUtils.getParameters(funcs[0]).filter(e => nodeUtils.isParameterLinked(e));

  const missingElements = [];

  for (let i = 0 ; i < names.length ; i++) {
    let found = false;

    for (let j = 0 ; j < paramsLinked.length ; j++) {
      if (names[i] === nodeUtils.getName(paramsLinked[j])) {
        found = true;
        if (nodeUtils.getIdTarget(paramsLinked[j]) !== idRef) {
          return { res: false, msg: `The reference of linked parameter '${nodeUtils.getName(paramsLinked[j])}' is erroneous - '${nodeUtils.getIdTarget(paramsLinked[j])}'`}
        }
      }
    }

    if (!found) {
      missingElements.push(names[i]);
    }
  }

  if (missingElements.length > 0) {
    return {
      res: false,
      msg: `The following parameters are missing: ${missingElements.join(", ")}.`,
    };
  }

  return {res: true, msg: "OK"}
}

export const validateParametersOutput = (root, fixed, names) => {
 const parent = nodeUtils.getFunctions(root)[0];

  if (!parent) {
    throw new Error("The parent is non-existent");
  }

  const elements = nodeUtils.getParameters(parent).filter(e => nodeUtils.getValueDefault(e)).map((e) => nodeUtils.getName(e));

  // if (fixed) {
  //   if (elements.length !== names.length) {
  //     return { res: false, msg: "The number of parameters is incorrect." };
  //   }
  // } else {
  //   if (elements.length < names.length) {
  //     return { res: false, msg: "The number of output parameters is too low." };
  //   }
  // }

  const missingElements = [];

  names.forEach((name) => {
    if (!elements.includes(name)) {
      missingElements.push(name);
    }
  });

  if (missingElements.length > 0) {
    return {
      res: false,
      msg: `The following output parameters are missing: ${missingElements.join(", ")}`,
    };
  }

  return { res: true, msg: "OK" };
}

export const validateParameterChoices = (root, global, fixed, name, choices) => {
  const parent = global ? root : nodeUtils.getFunctions(root)[0];

  if (!parent) {
    throw new Error("The parent is non-existent");
  }

  const container = nodeUtils.getParameters(parent).filter(e => nodeUtils.getName(e) === name);

  if (container.length === 0) {
    return {res: false, msg: `The parameter is missing: ${name}`}
  }

  const elements = nodeUtils.getChoices(container[0]).map((e) => nodeUtils.getName(e));

  // if (fixed) {
  //   if (elements.length !== choices.length) {
  //     return { res: false, msg: "The number of choices is incorrect." };
  //   }
  // } else {
  //   if (elements.length < choices.length) {
  //     return { res: false, msg: "The number of choices is too low." };
  //   }
  // }

  const missingElements = [];

  choices.forEach((name) => {
    if (!elements.includes(name)) {
      missingElements.push(name);
    }
  });

  if (missingElements.length > 0) {
    return {
      res: false,
      msg: `The following choices are missing: ${missingElements.join(", ")}`,
    };
  }

  return { res: true, msg: "OK" };
}

export const validateOutputParameterValues = (root, name, value) => {
  const parent = nodeUtils.getFunctions(root)[0];

  if (!parent) {
    throw new Error("The parent is non-existent");
  }

  const output = nodeUtils.getParameters(parent).filter(e => nodeUtils.getValueDefault(e)).filter(e => nodeUtils.getName(e) === name);

  if (output.length === 0) {
    return {res: false, msg: `The parameter is missing: ${name}`}
  }

  if (value !== nodeUtils.getValueDefault(output[0])) {
     return {
      res: false,
      msg: `The value is incorrect: ${nodeUtils.getName(output[0])}`,
    };
  }

  return { res: true, msg: "OK" };
}

export const validateLogicExpression = (root, name, expression) => {
    const parent = nodeUtils.getFunctions(root)[0];

  if (!parent) {
    throw new Error("The parent is non-existent");
  }

  const container = nodeUtils.getConditions(parent).filter(e => nodeUtils.getName(e) === name);

  if (container.length === 0) {
    return {res: false, msg: `The condition is missing: ${name}`}
  }

  const output = nodeUtils.getExpression(container[0])

    if (expression !== output) {
     return {
      res: false,
      msg: `The expression is incorrect: ${nodeUtils.getName(output)}`,
    };
  }

  return { res: true, msg: "OK" };
}